import React, { ReactElement } from 'react'
import TextInput from '../formGroup/TextInput'
import { IStepProps } from '../../interfaces/Step'
import Step2FormHook from '../../hooks/Step2FormHook'
import { preventEnterFormSubmit } from '../../services/utils'
import SubmitButton from '../SubmitButton'
import RevenueCardCollection from './RevenueCardsCollection'
import Step2ProfessionalSubCategory from './Step2ProfessionalSubCategory'
import Step2ActivitySector from './Step2ActivitySector'
import YesNoButtons from '../formGroup/YesNoButtons'
import Step2ProfessionalCategory from './Step2ProfessionalCategory'

const Step2Form = (props: IStepProps): ReactElement => {
  const {
    form,
    submitForm,
    handleNextStep,
    state,
    setState,
    validateFile,
    onRadioChange,
    updateRevenueCards,
    addRevenueCard,
    removeRevenueCard,
    csp_niv3,
    folderData,
    revenueCards,
    noRevenueChecked,
    professionSubcategories,
    isMediumOrLowRisk,
    handleProfessionalCategoryChange,
    handleProfessionalSubcategoryChange,
    multiFileUpload,
    setMultiFileUpload,
  } = Step2FormHook(props)
  const { profession, no_revenue } = folderData
  const { handleSubmit, register, errors, triggerValidation } = form

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form
      className="row"
      onSubmit={handleSubmit(submitForm)}
      onKeyPress={preventEnterFormSubmit}
    >
      <div className="col12">
        <p className="fontSizeXs mb1">Veuillez renseigner vos revenus.</p>
        <div className="dFlex alignItemsStart flexWrap flexColumn flexMdRow mb5">
          <strong className="fontWeightBold fontSizeSm fontStyleIt mb15 mb0lg mr3 mr5md">
            Je dispose d’un revenu (salariés, professionnels, immobiliers,
            mobiliers…)
          </strong>
          <div className="dFlex flexColumn">
            <YesNoButtons
              value={no_revenue || ''}
              register={register({ required: true })}
              error={errors.no_revenue}
              id="no_revenue"
              name="no_revenue"
              labelClassName="mb1"
              onChange={onRadioChange}
            />
          </div>
        </div>
      </div>
      {!noRevenueChecked && (
        <div className="col12">
          <div className="card px1 py1 row mx0 mb3">
            <Step2ProfessionalCategory
              register={register({ required: true })}
              onChange={handleProfessionalCategoryChange}
              errors={errors.professional_category}
            />

            <div
              className={`colMd6 ${
                professionSubcategories.length > 0 ? 'pl3lg mb25' : ''
              }`}
            >
              {professionSubcategories.length > 0 && (
                <Step2ProfessionalSubCategory
                  professionSubcategories={professionSubcategories}
                  register={register}
                  errors={errors}
                  onChange={handleProfessionalSubcategoryChange}
                />
              )}
            </div>
            <>
              <Step2ActivitySector
                errors={errors}
                register={register({ required: true })}
              />
              <TextInput
                register={register({
                  required: true,
                  validate: {
                    alphaInternational: (value) =>
                      !value.match('[^A-Za-zÀ-ÖØ-öø-ÿ ]') ||
                      'Seuls les caractères alphabétiques sont accceptés.',
                  },
                })}
                error={errors.profession}
                name="profession"
                id="profession"
                defaultValue={profession || ''}
                label="Profession"
                required
                className="colMd6 mb2 pl3lg"
                placeHolder="Votre texte ici..."
                inputClassName="inputFieldSecondary pr3"
                triggerValidation={triggerValidation}
              />
            </>
          </div>
        </div>
      )}
      <input
        type="hidden"
        name="csp_niv3"
        value={noRevenueChecked ? '9' : csp_niv3}
        ref={register}
        data-testid="cspNiv3"
      />

      {noRevenueChecked && (
        <input
          type="hidden"
          value={0}
          name="revenue[0][revenu_montant]"
          ref={register}
          data-testid="revenueMontant"
        />
      )}
      {!noRevenueChecked && (
        <div className="col12">
          <RevenueCardCollection
            revenueCards={revenueCards}
            removeRevenueCard={removeRevenueCard}
            updateRevenueCards={updateRevenueCards}
            addRevenueCard={addRevenueCard}
            register={register}
            errors={errors}
            state={state}
            setState={setState}
            validateFile={validateFile}
            isMediumOrLowRisk={isMediumOrLowRisk}
            triggerValidation={triggerValidation}
            multiFileUpload={multiFileUpload}
            setMultiFileUpload={setMultiFileUpload}
          />
        </div>
      )}
      <div className="col12 pt3 pt11md pb5 pb0md textRight">
        <SubmitButton label="Étape suivante" onClick={handleNextStep} />
      </div>
    </form>
  )
}

export default Step2Form
